<template>

    <div class="page-container">

        <header-band
            :back="true"
            :blueCleanfox="true"
            :title="$t('login_email_web_header')"
            @eventBack="eventBack"
        ></header-band>

        <email-redirect></email-redirect>

    </div>

</template>

<script>

import SessionStorage from '@/helpers/sessionStorage'

import Tag from '@/modules/tag'
import UserFlow from '@/modules/userFlow'

import EmailRedirect from '@/components/loginFlow/EmailRedirect.vue'
import HeaderBand from '@/components/headers/HeaderBand'
import InputText from '@/components/inputs/InputText'
import PageLoader from '@/components/PageLoader'
import ModalErrorProvider from '@/components/modal/ModalErrorProvider'
import Toast from '@/components/Toast'


export default {

    name: 'add-inbox',

    components: {EmailRedirect, HeaderBand, InputText, PageLoader, ModalErrorProvider, Toast},

    computed: {

        isDesktop: function () {
            return this.$mq === 'lg'
        }
    },

    created() {

        UserFlow.setPage(this, 'add_mailbox')

        const email = this.$route.params.email || ''
        SessionStorage.setItem('email', email)
    },

    methods: {

        eventBack() {

            Tag.clickAmplitude(this, 'back')
            this.$router.push({path: '/settings'})
        }

    }
}
</script>

<style lang="scss" scoped>

.page-container {
    width: 100%;
    min-height: inherit;
    display: flex;
    flex-direction: column;
    align-items: center;
    @media screen and (min-width: $above-tablet-length) {
        background-color: $timberwolf;
    }
}

.ai-container {
    display: flex;
    flex-direction: column;
    color: $midnight;
    padding: 0 16px;
    @media screen and (min-width: $above-tablet-length) {
        background-color: $white;
        max-width: 512px;
        margin-top: 120px;
        border-radius: 8px;
        box-shadow: 0 2px 10px 3px rgba(0, 0, 0, 0.15);
        padding: 0 32px 36px;
    }
}

.ai-title {
    font-size: 21px;
    font-weight: bold;
    margin-top: 21px;
    @media screen and (min-width: $above-tablet-length) {
        margin-top: 50px;
        font-size: 36px;
        line-height: 1.44;
    }
}

.ai-subtitle {
    margin-top: 7px;
    font-size: 12px;
    font-weight: 500;
    color: rgba(59, 59, 84, 0.6);
    @media screen and (min-width: $above-tablet-length) {
        margin-top: 4px;
        font-size: 20px;
        line-height: 1.5;
    }
}

.ai-input {
    margin-top: 20px;
    @media screen and (min-width: $above-tablet-length) {
        margin-top: 30px;
    }
}

.btn-ai {
    margin-top: 16px;
}

.ai-img {
    height: 74px;
    margin-top: 72px;
    object-fit: contain;
    @media screen and (min-width: $above-tablet-length) {
        margin-top: 64px;
        height: 92px;
    }
}

.ai-secu {
    margin-top: 11px;
    font-size: 10px;
    font-weight: 500;
    line-height: 1.6;
    color: $grey;
    @media screen and (min-width: $above-tablet-length) {
        margin-top: 16px;
        font-size: 12px;
        font-weight: 500;
        line-height: 1.33;
    }
}

</style>
